import { render, staticRenderFns } from "./Info_center.vue?vue&type=template&id=092e8d4a"
import script from "./Info_center.vue?vue&type=script&lang=js"
export * from "./Info_center.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports